<template>
  <div class="supplier-info-warp">
    <el-row class="supplier-info-top">
      <el-col class="item">
        <strong class="title">
          {{ detailInfo.supplierCompanyName}}
        </strong>
        <el-button type="primary">合作中</el-button>
      </el-col>
      <el-col class="item">
        <span class="contacts">联系人：{{ detailInfo.supplierPersonName || '暂无'}}</span>
        <span v-if="detailInfo && detailInfo.supplierPhone" class="telephone">{{ detailInfo.supplierPhone}}
          <i class="el-icon-document-copy"
          v-clipboard:copy="detailInfo.supplierPhone || ''"
          v-clipboard:success="() => $message.success('复制成功')"
          ></i>
        </span>
      </el-col>
      <el-col class="item no-pad">
        主营平台：
        <el-avatar v-for="item in detailInfo.platformInfoList" :key="item.source" shape="square" size="small" :src="PLATFORM_ICONS_MAP[item.source]"></el-avatar>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { PLATFORM_ICONS_MAP } from '@/dictionary/platforms.js'
export default {
  props: {
    detailInfo:{
      type: Object,
      default: () => {
        return {
          supplierCompanyName: '',
          supplierPersonName: '',
          supplierPhone: '',
          platformInfoList: []
        };
      }
    }
  },
  data() {
    return {
      squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      PLATFORM_ICONS_MAP,
    }
  },
}
</script>

<style lang="scss" scoped>
.supplier-info-warp{
  font-size: 12px;
  margin-bottom: 15px;
}
.supplier-info-top{
  padding: 12px 8px;
  border: 1px solid #DDDEDE;
  border-radius: 5px;
}
.item{
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  .el-avatar--small{
    margin-right: 10px;
  }
}
.no-pad {
  padding-bottom: 0px;
}
.title{
  padding-right: 15px;
  font-size: 15px;
}
.contacts{
  padding-right: 30px;
}
.el-icon-document-copy{
  font-size: 18px;
  cursor: pointer;
}
.improved-item{
  margin-right: 10px;
  // display: flex;
  // align-items: flex-end;
}
.improved-platform{
  display: flex;
  padding: 15px 0;
  align-items: flex-end;
}
</style>